// extracted by mini-css-extract-plugin
export default {"container":"MarketReportTable_container__0D7ks","link":"MarketReportTable_link__rKUe8"};